export { FranchisesService } from './franchises.service';
